<template>
  <el-dialog v-model="dialogVisible" :close-on-click-modal="false" :show-close="false"
    :before-close="handleClose" width="40%">
    <template #title>
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <span>{{ isEdit ? 'Edit Vendor' : 'Add Vendor' }}</span>
        <div style="display: flex; align-items: center; gap: 6px;">
          <el-button size="small" type="warning" @click="resetForm">Reset</el-button>
          <el-button size="small" @click="handleClose">X</el-button>
        </div>
      </div>
    </template>

    <el-form :model="form" ref="formRef" :rules="rules" label-width="150px" size="small">
      <el-form-item label="Name: " prop="name">
        <el-input v-model="form.name" style="width: 250px"></el-input>
      </el-form-item>
      <el-form-item label="Email: " prop="email">
        <el-input v-model="form.email" style="width: 250px"></el-input>
      </el-form-item>
      <el-form-item label="Phone: " prop="phone">
        <el-input v-model="form.phone" style="width: 250px"></el-input>
      </el-form-item>
      <el-form-item label="Address: " prop="address">
        <el-input v-model="form.address" style="width: 250px"></el-input>
      </el-form-item>
      <el-form-item label="Remark: " prop="remark">
        <el-input v-model="form.remark" type="textarea" :rows="5" style="width: 250px"></el-input>
      </el-form-item>
      <el-form-item label="Status: " prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">Active</el-radio>
          <el-radio :label="0">Disabled</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button size="small" @click="handleClose">Cancel</el-button>
      <el-button type="primary" size="small" @click="handleSubmit">Confirm</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { ElMessageBox } from 'element-plus'
import { useMutation } from '@/composables/useMutation'
import { registerVendor, updateVendor } from '@/api/vendor'
import { defaultVendor } from '../../defaults'

const props = defineProps({
  visible: { type: Boolean, default: false },
  row: { type: Object, default: null }
})

const emit = defineEmits(['update:visible', 'saved'])

const dialogVisible = computed({
  get: () => props.visible,
  set: (val) => emit('update:visible', val)
})

const { mutate } = useMutation({ useOverlay: true })

const formRef = ref(null)
const isEdit = ref(false)
const form = ref({ ...defaultVendor })

const rules = {
  name: [{ required: true, message: 'This field is required', trigger: 'blur' }],
  phone: [{ required: true, message: 'This field is required', trigger: 'blur' }]
}

watch(() => props.visible, (val) => {
  if (val) {
    if (props.row) {
      isEdit.value = true
      form.value = { ...props.row }
    } else {
      isEdit.value = false
      form.value = { ...defaultVendor }
    }
  }
})

function resetForm() {
  formRef.value?.resetFields()
}

function handleClose() {
  formRef.value?.resetFields()
  dialogVisible.value = false
}

async function handleSubmit() {
  const valid = await formRef.value?.validate().catch(() => false)
  if (!valid) return

  ElMessageBox.confirm('Are you sure to submit this form?', 'Warning', {
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    type: 'warning'
  }).then(async () => {
    const action = isEdit.value
      ? () => updateVendor(form.value.id, form.value)
      : () => registerVendor(form.value)

    await mutate(action, {
      success: isEdit.value ? 'Successfully updated!' : 'Successfully created!',
      onSuccess: () => {
        dialogVisible.value = false
        emit('saved')
      }
    })
  }).catch(() => { })
}
</script>
